export enum FileIcon {
  Generic = 'insert_drive_file',
  Text = 'description',
  Image = 'image',
}
